function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M4.52175 0.521646L4.52175 6.74593C4.52175 7.03387 4.28805 7.26757 4.0001 7.26757C3.71215 7.26757 3.47845 7.03387 3.47845 6.74593L3.47845 0.521646C3.47845 0.233697 3.71215 2.04305e-08 4.0001 4.56037e-08C4.28805 7.0777e-08 4.52175 0.233697 4.52175 0.521646Z",
  fill: "#E24D4D"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.99994 6.74601C7.99994 6.84339 7.97281 6.93937 7.91995 7.02422L4.44162 12.5439C4.34563 12.6956 4.1794 12.7881 3.99996 12.7881C3.82051 12.7881 3.65428 12.6956 3.5583 12.5439L0.0799618 7.02422C-0.0208898 6.86356 -0.0271495 6.66046 0.0653557 6.49423C0.157165 6.3273 0.331743 6.22437 0.521622 6.22437L7.47829 6.22437C7.66817 6.22437 7.84275 6.3273 7.93456 6.49423C7.97838 6.57283 7.99994 6.65977 7.99994 6.74601Z",
  fill: "#E24D4D"
});

function SvgArrowdown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.b9384d88.svg";
export { ForwardRef as ReactComponent };